import React from 'react';
import { CompactError, RobbieMark } from '../../ui';

/**
 * Robbie writing a thread's opening questions — one model call, so one quiet
 * line and no progress theatre. Past the timeout the wait becomes an honest
 * error: what happened, and that the composer still works.
 */
interface KickoffDraftingProps {
  supplierName: string;
  timedOut: boolean;
  onRetry?: () => void;
}

const KickoffDrafting: React.FC<KickoffDraftingProps> = ({ supplierName, timedOut, onRetry }) => {
  if (timedOut) {
    return (
      <CompactError
        layout="row"
        title={`I couldn’t draft opening questions for ${supplierName}`}
        message="Write your own ask below, or let me try again."
        action={onRetry ? { label: 'Try again', onClick: onRetry } : undefined}
      />
    );
  }
  return (
    <div
      role="status"
      className="flex items-center gap-s3 rounded-card border border-robbie-border bg-robbie-bg px-s5 py-s4"
    >
      <RobbieMark size="xs" state="working" aria-label="Robbie is drafting" />
      <div className="min-w-0">
        <p className="m-0 text-row-title text-ink">Drafting opening questions for {supplierName}</p>
        <p className="m-0 text-body-sm text-ink-secondary">I&rsquo;ll put them in the thread in a moment.</p>
      </div>
    </div>
  );
};

export default KickoffDrafting;
